import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconSliderComponent } from "./med-icon-slider.component";

@NgModule({
  declarations: [
    MedIconSliderComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconSliderComponent,
  ],
})
export class MedIconSliderModule { }
